import React, { useState, useEffect, useContext } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { customFilter } from 'react-bootstrap-table2-filter';
import { LabelText } from '../../../components/Language';
import { OverviewContext } from '../../../NmbsUser/context/OverviewProvider';
import { AuditContext } from '../../../Audit/context/AuditProvider';
import FilterOverlayTrigger from '../../../components/UI/Filter/FilterOverlayTrigger';
import {LanguageContext} from '../../../containers/Language/LanguageProvider';
import './index.css';

export default function Overview(props) {
    const [overviewData, setData] = useState([]);
    const [selected, setSelected] = useState(undefined);
    const [expendedRowList, setExpendedRowList] = useState([]);
    const [isPartiallyChecked, setIsPartiallyChecked] = useState(undefined);
    const { handlerOnClearFilterClick, isClearOverviewFilter, isOverviewFilterApplied,
        handlerCheckOverviewFilterApplied, overviewFilterData, overviewColumnFilterIndexes,
        handlerSetOverviewFilterData } = useContext(!props.isAudit ? OverviewContext : AuditContext);
    const [filterData, setFilterData] = useState(overviewFilterData && overviewFilterData.length > 0 ? 
                                        overviewFilterData : []);
    const [columnFilterIndexes, setColumnFilterIndexes]=useState(overviewColumnFilterIndexes && 
                                                        overviewColumnFilterIndexes.length > 0 ? 
                                                        overviewColumnFilterIndexes :[]);
    const [columnFilterOptions, setColumnFilterOptions]=useState(new Map());
    const { language } = useContext(LanguageContext);

    useEffect(() => {
        let dataArray = []

        if(filterData && filterData.length > 0) {
            dataArray=filterData;
        }
        else if (props.overview && props.overview.length > 0) {
            dataArray = props.overview;
        }

        setData(dataArray);
        selectedBusinessPartner(dataArray);
        setHeaderSelection(true, dataArray);         
        const expandableRow = !expendedRowList ? expendedRowList : dataArray.filter(d=>d.contractDetails
                                                                    .some(c=>c.isChecked) || d.isChecked)
                                                                    .map(row => row.businessPartnerId);
        setExpendedRowList(expandableRow);
    }, [props.overview, props.isBtnDetailsEnable]);

    useEffect(() => {
        if(isClearOverviewFilter) {
            setData([]);
            setFilterData([]);
            setColumnFilterIndexes([]);
            setColumnFilterOptions(new Map());
            handlerOnClearFilterClick(false, true);
            handlerSetOverviewFilterData([], []);
        }
    }, [isClearOverviewFilter]);

    useEffect(() => {
        let header = document.querySelectorAll(".Overview-datatable thead th");
            if (header && header.length > 0) {
                header.forEach(element => { element.setAttribute("tabindex", "-1"); });
            }
    }, []);

    let data = isOverviewFilterApplied && filterData && filterData.length > 0 ? filterData 
                : overviewData && overviewData.length > 0 ? overviewData
                : props.overview && props.overview.length > 0 ? props.overview : [];
    
    const getMainRowFieldData = (row, fieldName) => {
        return (
            <div>
                {
                    fieldName == 'billingRule' || fieldName == 'conditionRule' ?
                        row.contractDetails && row.contractDetails.length > 1 ? ""
                            : <span><LabelText tid={row.contractDetails[0][fieldName]} /></span>
                        : row.contractDetails && row.contractDetails.length > 1 ? ""
                            : <span>{row.contractDetails[0][fieldName]}</span>
                }
            </div>
        )
    }

    const getExpendableRowData = (row) => { 
        let expand, selection, businessPartnerName, contractCode, concessionName, station, room, startDate, endDate, status, billingRule, condition, crmtDate, contactEmail, businessPartnerCode;

        if(language.id === "1")
        {
            expand="expand-inner-cell-header";
            selection="selection-inner-cell-header";
            businessPartnerName="businessPartnerName-inner-header";
            contractCode="contractCode-inner-header";
            billingRule="billingRule-inner-header";
            condition="condition-inner-header";
            crmtDate="crmtDate-inner-header";
            concessionName="concessionName-inner-header";
            station="station-inner-header";
            room="room-inner-header";
            startDate="startDate-inner-header";
            endDate="endDate-inner-header";
            status="status-inner-header";            
            contactEmail="contactEmail-inner-header";
            businessPartnerCode="businessPartnerCode-inner-header";                      
        }
        else if(language.id === "2")
        {            
            concessionName="concessionName-inner-header-fr";
            station="station-inner-header-fr";
            room="room-inner-header-fr";
            startDate="startDate-inner-header-fr";
            endDate="endDate-inner-header-fr";
            status="status-inner-header-fr";
            billingRule="billingRule-inner-header-fr";
            condition="condition-inner-header-fr";
            crmtDate="crmtDate-inner-header-fr";
            contactEmail="contactEmail-inner-header-fr";
            businessPartnerCode="businessPartnerCode-inner-header-fr";
            expand="expand-inner-cell-header-fr";
            selection="selection-inner-cell-header-fr";
            businessPartnerName="businessPartnerName-inner-header-fr";
            contractCode="contractCode-inner-header-fr";
        }
        else if(language.id === "3")
        {
            expand="expand-inner-cell-header-nl";
            selection="selection-inner-cell-header-nl";
            businessPartnerName="businessPartnerName-inner-header-nl";
            contractCode="contractCode-inner-header-nl";
            concessionName="concessionName-inner-header-nl";
            station="station-inner-header-nl";
            room="room-inner-header-nl";
            startDate="startDate-inner-header-nl";
            endDate="endDate-inner-header-nl";
            status="status-inner-header-nl";
            billingRule="billingRule-inner-header-nl";
            condition="condition-inner-header-nl";
            crmtDate="crmtDate-inner-header-nl";
            contactEmail="contactEmail-inner-header-nl";
            businessPartnerCode="businessPartnerCode-inner-header-nl";
        }
        else if(language.id === "4")
        {
            expand="expand-inner-cell-header-de";
            selection="selection-inner-cell-header-de";
            station="station-inner-header-de";
            room="room-inner-header-de";
            startDate="startDate-inner-header-de";
            endDate="endDate-inner-header-de";
            businessPartnerName="businessPartnerName-inner-header-de";
            contractCode="contractCode-inner-header-de";
            concessionName="concessionName-inner-header-de";            
            status="status-inner-header-de";
            billingRule="billingRule-inner-header-de";
            condition="condition-inner-header-de";
            crmtDate="crmtDate-inner-header-de";
            contactEmail="contactEmail-inner-header-de";
            businessPartnerCode="businessPartnerCode-inner-header-de";
        }
        return (
            <table className="Overview-inner-table">
                <thead style={{ display: "table-header-group", visibility: "collapse", padding: "0" }}>
                    <tr className="Overview-datatable-header" 
                        style={{ lineHeight:"7vh", color: row.index % 2 === 0 ? '#eff4f9' : '#ffffff' }}
                    >
                        <th className={expand}></th>
                        <th className={selection}></th>
                        <th className={businessPartnerName}> <LabelText tid="businesspartnername" /><div class="filter-overlay">&nbsp;</div></th>
                        <th className={contractCode}><LabelText tid="contractcode" /><div class="filter-overlay">&nbsp;</div></th>
                        <th className={concessionName}><LabelText tid="concessionname" /><div class="filter-overlay">&nbsp;</div></th>
                        <th className={station}><LabelText tid="station" /><div class="filter-overlay">&nbsp;</div></th>
                        <th className={room}><LabelText tid="room" /><div class="filter-overlay">&nbsp;</div></th>
                        <th className={startDate}><LabelText tid="startdate" /><div class="filter-overlay">&nbsp;</div></th>
                        <th className={endDate}><LabelText tid="enddate" /><div class="filter-overlay">&nbsp;</div></th>
                        <th className={status}><LabelText tid="status" /><div class="filter-overlay">&nbsp;</div></th>                        
                        <th className={billingRule}><LabelText tid="billing_rule" /><div class="filter-overlay">&nbsp;</div></th>
                        <th className={condition}><LabelText tid="condition_rule" /><div class="filter-overlay">&nbsp;</div></th>
                        <th className={crmtDate}><LabelText tid="crmt_date" /><div class="filter-overlay">&nbsp;</div></th>
                        <th className={contactEmail}><LabelText tid="contact_email" /><div class="filter-overlay">&nbsp;</div></th> 
                        <th className={businessPartnerCode}><LabelText tid="businesspartnercode" /><div class="filter-overlay">&nbsp;</div></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        row.contractDetails.map((item, index) => {
                            return (<tr key={item.contractId} style={{
                                display: "table-row",
                                verticalAlign: "inherit",
                                borderColor: "inherit",   
                                lineHeight:"7vh",                            
                                backgroundColor: row.index % 2 !== 0 ?
                                    (index % 2 !== 0 ? '#eff4f9' : '#ffffff') :
                                    (index % 2 === 0 ? '#eff4f9' : '#ffffff')
                            }}
                            >
                                <td className="expand-cell" style={{
                                    color: row.index % 2 === 0 && index % 2 === 0 ? '#eff4f9'
                                        : '#ffffff'
                                }}>(+)</td>
                                <td className="selection-cell inner-cell-checkbox"><input type="checkbox" checked={item.isChecked}
                                    title="Contract code checkbox"
                                    onChange={(ev) => handleOnContractSelect(ev, row, item.contractId)} /></td>
                                <td><div className="contractDtl-businessPartnerName-dashbox">|---------------------</div></td>
                                <td>{item.contractCode}</td>
                                <td className="concession-name">{item.concessionName}</td>
                                <td className="station">{item.stationName}</td>
                                <td className="room">{item.room}</td>
                                <td className="startDate">{item.contractStartDate}</td>
                                <td className="endDate">{item.contractEndDate}</td>
                                <td className="contractstatus">{item.contractStatus}</td>
                                <td><LabelText tid={item.billingRule} /></td>
                                <td><LabelText tid={item.conditionRule} /></td>
                                <td>{item.crmtDate}</td>
                                <td className="Overview-Contractemail">{item.contactEmail}</td> 
                                <td>&nbsp;</td>
                            </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        )
    }

    const handlerFilterOverlayTrigger = (column, colName, isDate, isNested, nestedObjectField, 
        isTotalColumn, isDropdown, isRuleValue, isNestedArray, isOverviewColumnFilter) => {
        return (<FilterOverlayTrigger column={column}
            colName={colName}
            isDate={isDate}
            isNested={isNested}
            nestedObjectField={nestedObjectField}
            isTotalColumn={isTotalColumn}
            filterData={filterData}
            data={columnFilterIndexes && columnFilterIndexes.length > 1 ? data : props.overview}
            columnFilterIndexes={columnFilterIndexes}
            columnFilterOptions={columnFilterOptions}
            setFilterData={setFilterData}
            setColumnFilterIndexes={setColumnFilterIndexes}
            setColumnFilterOptions={setColumnFilterOptions}
            isDropdown={isDropdown}
            isRuleValue={isRuleValue}
            isNestedArray={isNestedArray}
            isOverviewColumnFilter={isOverviewColumnFilter}
            overviewColumnFilterIndexes={overviewColumnFilterIndexes}
            handlerCheckOverviewFilterApplied={handlerCheckOverviewFilterApplied}
        />);
    }

    const columns = [
        {
            dataField: 'businessPartnerId',
            columnIndex: 0,
            hidden: true
        },
        {
            dataField: 'businessPartnerName',
            text: <LabelText tid="businesspartnername" />,
            classes: "businessPartnerName",
            headerClasses: "businessPartnerName-header",
            editable: false,
            columnIndex: 1,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "businessPartnerName", false, 
                                                false, null, false, false, false, false, true)
        },
        {
            dataField: 'contractDetails[0].contractCode',
            editable: false,
            headerClasses: "contractCode-header",
            text: <LabelText tid="contractcode" />,
            formatter: (cell, row, rowIndex) => {
                return getMainRowFieldData(row, "contractCode");
            },  
            columnIndex: 2,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "contractCode", false, true, 
                                                "contractDetails", false, false, false, true, true)
        },
        {
            dataField: 'contractDetails[0].concessionName',
            headerClasses: "concessionName-header",
            text: <LabelText tid="concessionname" />,
            columnIndex: 3,
            editable: false,
            formatter: (cell, row, rowIndex) => {
                return getMainRowFieldData(row, "concessionName");
            },
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "concessionName", false, true, 
                                                "contractDetails", false, false, false, true, true)            
        },
        {
            dataField: 'contractDetails[0].stationName',
            formatter: (cell, row, rowIndex) => {
                return getMainRowFieldData(row, "stationName");
            },
            text: <LabelText tid="station" />,
            editable: false,
            columnIndex: 4,
            headerClasses: "station-header",
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "stationName", false, true, 
                                                "contractDetails", false, false, false, true, true)
        },
        {
            dataField: 'contractDetails[0].room',
            editable: false,
            text: <LabelText tid="room" />,
            formatter: (cell, row, rowIndex) => {
                return getMainRowFieldData(row, "room");
            },
            headerClasses: "room-header",
            columnIndex: 5,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "room", false, true, 
                                                "contractDetails", false, false, false, true, true)
        },
        {
            dataField: 'contractDetails[0].contractStartDate',
            text: <LabelText tid="startdate" />,           
            formatter: (cell, row, rowIndex) => {
                return getMainRowFieldData(row, "contractStartDate");
            },  
            columnIndex: 6,
            editable: false,
            headerClasses: "startDate-header",
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "contractStartDate", true, true, 
                                                "contractDetails", false, false, false, true, true)
        },
        {
            headerClasses: "endDate-header",
            dataField: 'contractDetails[0].contractEndDate',
            text: <LabelText tid="enddate" />,
            editable: false,
            formatter: (cell, row, rowIndex) => {
                return getMainRowFieldData(row, "contractEndDate");
            },
            columnIndex: 7,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "contractEndDate", true, true, 
                                                "contractDetails", false, false, false, true, true)
        },
        {
            dataField: 'contractDetails[0].contractStatus',
            formatter: (cell, row, rowIndex) => {
                return getMainRowFieldData(row, "contractStatus");
            },
            text: <LabelText tid="status" />,
            editable: false,
            columnIndex: 8,
            headerClasses: "status-header",
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "contractStatus", false, true, 
                                                "contractDetails", false, false, false, true, true)        
        },
        {
            headerClasses:"billingRule-header",
            dataField: 'contractDetails[0].billingRule',
            text: <LabelText tid="billing_rule" />,
            editable: false,
            formatter: (cell, row, rowIndex) => {
                return getMainRowFieldData(row, "billingRule");
            },
            columnIndex: 9,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "billingRule", false, true, 
                                                "contractDetails", false, false, true, true, true)
        },
        {
            dataField: 'contractDetails[0].conditionRule',
            text: <LabelText tid="condition_rule" />,
            editable: false,
            headerClasses: "condition-header",
            columnIndex:10,
            formatter: (cell, row, rowIndex) => {
                return getMainRowFieldData(row, "conditionRule");
            },
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "conditionRule", false, true, 
                                                "contractDetails", false, false, true, true, true)
        },
        {
            dataField: 'contractDetails[0].crmtDate',
            headerClasses: "crmtDate-header",
            text: <LabelText tid="crmt_date" />,
            editable: false,
            formatter: (cell, row, rowIndex) => {
                return getMainRowFieldData(row, "crmtDate");
            },
            columnIndex: 11,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "crmtDate", true, true, 
                                                "contractDetails", false, false, false, true, true)
        },
        {            
            headerClasses: "contactEmail-header",
            dataField: 'contractDetails[0].contactEmail',
            classes: "Overview-Contractemail",
            editable: false,
            text: <LabelText tid="contact_email" />,
            columnIndex: 12,
            formatter: (cell, row, rowIndex) => {
                return getMainRowFieldData(row, "contactEmail");
            },
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "contactEmail", false, true, 
                                                "contractDetails", false, false, false, true, true)
        },
        {
            headerClasses: "businessPartnerCode-header",
            dataField: 'businessPartnerCode',
            text: <LabelText tid="businesspartnercode" />,
            editable: false,
            columnIndex: 13,
            filter: customFilter(),
            filterRenderer: (onFilter, column) => handlerFilterOverlayTrigger(column, "businessPartnerCode", false, 
                                                false, null, false, false, false, false, true)
        }
    ];

    const tableRowClasses = (row, rowIndex) => {
        row.index = rowIndex;
        let classes = {};
        if (rowIndex % 2 === 0)
            classes = 'even-row';
        else
            classes = 'odd-row';

        if (row.contractDetails.length === 1)
            classes = classes + " row-notExpandable"

        return classes;
    }

    const selectedBusinessPartner = (selectedPartnerData) => {
        const selectedBusinessPartnerId = selectedPartnerData && selectedPartnerData.reduce((arr, item, index) => {
            if (item.isChecked || item.contractDetails.every(d => d.isChecked))
                arr.push(item.businessPartnerId)
            return arr;
        }, []);
        setSelected(selectedBusinessPartnerId);
    }

    const setRowLevelData = (rowLevelData, row, isSelect) => {        
        row.isChecked = isSelect;  
        const contractDetails = row.contractDetails.map(d => {            
            return {
                ...d,
                isChecked: isSelect,                
            }
        });
        row.contractDetails = contractDetails; 
        row.isBPPartialyChecked = false;         
        rowLevelData[row.index] = row;        
    }

    const setAllData = (allData) => {
        setData(allData);
        selectedBusinessPartner(allData);
        if(filterData && filterData.length > 0) {
            setFilterData(allData);
            handlerSetOverviewFilterData(allData, overviewColumnFilterIndexes);
        } else {
            props.overviewDataSelectionHandler(allData);
        }
    }

    const setHeaderSelection = (isSelectAll, headerData) => {
        const isSelected = headerData && (headerData.some(d=>d.contractDetails.some(c=>c.isChecked)) || headerData.some(e=>e.isChecked));
        !isSelectAll ? setIsPartiallyChecked(undefined) : setIsPartiallyChecked(isSelected);        
    }

    const handleOnSelect = (row, isSelect) => {        
        let selectedData = filterData && filterData.length > 0 ? filterData : overviewData;
        setRowLevelData(selectedData, row, isSelect);
        setAllData(selectedData);
        setHeaderSelection(true, selectedData); 
    }

    const handleOnSelectAll = (isSelect) => {            
        let overview_data = filterData && filterData.length > 0 ? filterData : overviewData;   
        isSelect = overview_data.some(d=>d.contractDetails.some(c=>c.isChecked)) ? false : isSelect;  
        overview_data.map((row)=> {
                setRowLevelData(overview_data, row, isSelect);                
            });
        setAllData(overview_data);        
        !isSelect && setHeaderSelection(isSelect, overview_data); 
    }

    const handleOnContractSelect = (ev, row, contractId) => {
        const isSelect = ev.target.checked;        
        let selectedContractData = filterData && filterData.length > 0 ? filterData : overviewData;
        const contractDetails = row.contractDetails.map(d => {
            return {
                ...d,
                isChecked: d.contractId === contractId ? isSelect : d.isChecked,
            }
        });
        row.contractDetails = contractDetails;
        const everySelected = row.contractDetails.every(d => d.isChecked); 
        row.isChecked = everySelected;  
        row.isBPPartialyChecked = row.contractDetails.some(d => d.isChecked) && !everySelected;  
        selectedContractData[row.index] = row;
        setAllData(selectedContractData);
        setHeaderSelection(true, selectedContractData);
    }
  
    var isEdge = !(false || !!document.documentMode) && !!window.StyleMedia;
    var isEdgeChromium = (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime))
     && (navigator.userAgent.indexOf("Edg") != -1);    

        const selectRow = {
        mode: 'checkbox',  
        clickToSelect: false,  
        selectColumnStyle: ({            
            rowIndex
          }) => {                    
            if(data && data[rowIndex].isBPPartialyChecked && (data[rowIndex].contractDetails && data[rowIndex].contractDetails.length > 1))
              {              
              return {    
                 backgroundColor: (isEdgeChromium || isEdge) ? '#6c757d' :'#25336c'                        
              };
            }
            return {
             backgroundColor: rowIndex % 2 === 0 ? '#ffffff' : '#eff4f9'
            };
          },
       
        selected: selected,   
        selectionRenderer: ({ mode, rowIndex, ...rest }) => (
            <input type={ mode } 
            title="Business partner checkbox"                    
            { ...rest }
             />
        ),            
        selectionHeaderRenderer: ({ mode, indeterminate, ...rest }) => (
            <input
              type={ mode }
              ref={ (input) => {
                if (input ){ input.indeterminate = (data && (data.every(d=>d.isChecked))) ? undefined : isPartiallyChecked ; 
                }             
              } }
              { ...rest }
            />
          ),
        onSelect: (row, isSelect) => handleOnSelect(row, isSelect),
        onSelectAll: (isSelect, rows) => handleOnSelectAll(isSelect)              
    }   

    const expandColumnHandler = (expanded, rowKey, expandable) => {
        return (<div role= {expandable ? "button" : undefined} tabIndex={expandable ? "0" : "-1"} className="expanded" 
                onKeyDown={(e)=>{ if (expandable && e.key === "Enter") handleOnKeyDownExpand(expanded, rowKey)}}>
            <span className="expanded-span">
                {expanded ? "-" : "+"}
            </span>
        </div>);
    }

    const handleOnKeyDownExpand = (isExpand, rowKey) => {
        if(!expendedRowList) {
            setExpendedRowList([]);
        }
        setExpandedRowId(expendedRowList.length === 0, rowKey)        
    }
    const setExpandedRowId = (isExpand, rowKey) => {
        if (isExpand) {
            setExpendedRowList(prevArray => [...prevArray, rowKey]);                        
        } else {
            setExpendedRowList(expendedRowList.filter(( id ) => id !== rowKey));
        }

    }
    
    const handleOnExpand = (row, isExpand, rowIndex, e) => {
        setExpandedRowId(isExpand, row.businessPartnerId)         
    }

    const expandRow = {
        renderer: (row) => row && row.contractDetails && row.contractDetails.length > 1 && getExpendableRowData(row),
        expandColumnRenderer: ({ expanded, rowKey, expandable }) => expandColumnHandler(expanded, rowKey, expandable),
        expanded: expendedRowList,
        onExpand: handleOnExpand,
        showExpandColumn: true,
        expandByColumnOnly: true,
        onlyOneExpanding: true,
        nonExpandable: data.length > 0 && data.reduce((arr, item, index) => {
                if (item.contractDetails.length === 1) { arr.push(item.businessPartnerId) }
                return arr;
                }
        , []),
    }
    
    return (
        <div>
            <BootstrapTable
                keyField='businessPartnerId'
                data={filterData && filterData.length > 0 ? filterData : data}
                columns={columns}
                noDataIndication={<LabelText tid="Noactivecontract" />}
                bordered
                filter={ filterFactory() } 
                rowClasses={tableRowClasses}
                classes={!props.isAudit ? "Overview-datatable scroller" : "Overview-datatable audit scroller"}
                headerClasses={"Overview-datatable-header"}
                selectRow={selectRow}
                expandRow={expandRow}
            />
        </div>
    );
}